import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/css3-alt': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M0 32h384l-34.9 395.8-157.1 52.2-157.1-52.2zM313.1 112h-242.2l5.8 47.3h122.9l-6.5 2.7-112.1 46.7 3.6 46.3 0.2-0.1v0.1l166.3 0.5-3.7 61.6-54.7 15.4-52.6-13.3-3.2-38.3h-48.9l6.4 73.9 98.8 29.2 98.2-28.7 12.8-146.6h-111.5l0.3-0.1 115.3-49.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/css3-alt.js
// module id = 778
// module chunks = 0